import { render } from "./DatevIndex.vue?vue&type=template&id=13d59b8c"
import script from "./DatevIndex.vue?vue&type=script&lang=js"
export * from "./DatevIndex.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__